import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LogGet } from '../../services';

export const fetchLogGet = createAsyncThunk(
    'logGet/fetchLogGet',
    async () => {
        const response = await LogGet()
        return response.result
    }
);

const logGetSlice = createSlice({
    name: 'logGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLogGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLogGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default logGetSlice.reducer;
